import { useState } from 'react';
import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect.js';
import { isSSR } from '../utils/dom.js';

function useIsServerEffect(fallback = true) {
  const [isServer, setIsServer] = useState(fallback);
  useIsomorphicLayoutEffect(() => {
    setIsServer(isSSR);
  });
  return isServer;
}

export { useIsServerEffect };
